import { render } from "./GymPrivacy.vue?vue&type=template&id=a3033288&scoped=true"
import script from "./GymPrivacy.vue?vue&type=script&lang=js"
export * from "./GymPrivacy.vue?vue&type=script&lang=js"

import "./GymPrivacy.vue?vue&type=style&index=0&id=a3033288&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3033288"]])

export default __exports__